module.exports = __webpack_public_path__ + "img/street-view.83bc224e.svg";